import React, { useState, useEffect } from 'react';
import './policypage.css';
import PageSerch from '../SerchDocters/Components/PageSerch';
import DynamicBreadcrumbs from '../../../Uitiles/DynamicBreadcrumbs';
import PageSidebar from '../../../Uitiles/PageSidebar';
import useInsurancePayment from '../../../hooks/useInsurancePayment';

const tabs = [
	{ key: 'term', label: 'Term Insurance' },
	{ key: 'investment', label: 'Investment Plans' },
];

const DEFAULT_COMPANY_ID = Number(process.env.REACT_APP_DEFAULT_INSURANCE_COMPANY_ID || 0) || null;

const policies = [
	{
		id: 'icici-term',
		insurer: 'ICICI Prudential',
		logo: '/assets/images/brands/icici-pru.png',
		policyNumber: 'POL-ICICI-TERM',
		companyId: DEFAULT_COMPANY_ID || 1,
		product: 'iProtect Smart Plus',
		lifeCover: '₹ 1 Cr',
		claimSettled: '99.3%',
		premium: '₹ 1,499/month',
		badges: ['100% payout on Terminal illness', 'Option to delay 12 Months premium'],
		savings: 'Buy Online & Save ₹7.0K',
	},
	{
		id: 'hdfc-term',
		insurer: 'HDFC Life',
		product: 'Click 2 Protect',
		policyNumber: 'POL-HDFC-TERM',
		companyId: DEFAULT_COMPANY_ID || 1,
		lifeCover: '₹ 1 Cr',
		claimSettled: '99.7%',
		premium: '₹ 1,899/month',
		badges: ['Full refund of premium', 'Upto 15% discount included'],
		savings: 'Limited Pay Option',
	},
	{
		id: 'lic-term',
		insurer: 'LIC',
		logo: '/assets/images/brands/lic.png',
		policyNumber: 'POL-LIC-TERM',
		companyId: DEFAULT_COMPANY_ID || 1,
		product: 'Jeevan Anand',
		lifeCover: '₹ 1 Cr',
		claimSettled: '98.9%',
		premium: '₹ 2,099/month',
		badges: ['Guaranteed returns', 'Maturity benefit available'],
		savings: 'Special discount for women',
	},
];

const investmentPlans = [
	{
		id: 'axis',
		logo: '/assets/images/brands/axis-life.png',
		insurer: 'AXIS MAX LIFE INSURANCE',
		product: 'Online Savings Plan',
		returns: '17.8%',
		returnsBadge: 'High Growth Fund',
		payout: '₹ 1.34 Cr',
		payoutNote: 'If you had invested 20 Yrs ago'
	},
	{
		id: 'tata',
		logo: '/assets/images/brands/tata-aia.png',
		insurer: 'TATA AIA LIFE INSURANCE',
		product: 'Smart Fortune Plus-Wealth Secure',
		returns: '17.9%',
		returnsBadge: 'Top 200 Fund',
		payout: '₹ 1.34 Cr',
		payoutNote: 'If you had invested 20 Yrs ago'
	}
];

export default function PolicyPage() {
	const [activeTab, setActiveTab] = useState('term');
	const [showModal, setShowModal] = useState(false);
	const [modalTab, setModalTab] = useState('term');
	const { startPayment, processingKey } = useInsurancePayment();

	useEffect(() => {
		if (showModal) {
			document.body.classList.add('modal-open');
		} else {
			document.body.classList.remove('modal-open');
		}
		return () => {
			document.body.classList.remove('modal-open');
		};
	}, [showModal]);

	// Handle country dropdown functionality
	useEffect(() => {
		if (showModal) {
			const setupCountryDropdown = () => {
				const countryInput = document.getElementById('termCountry');
				const dropdownList = document.getElementById('dropdownList');
				const searchInput = document.getElementById('searchCountry');
				const countryCodeInput = document.getElementById('countryCode');
				const countryList = document.getElementById('countryList');

				if (countryInput && dropdownList) {
					// Toggle dropdown
					countryInput.addEventListener('click', () => {
						dropdownList.style.display = dropdownList.style.display === 'none' ? 'block' : 'none';
					});

					// Search functionality
					if (searchInput && countryList) {
						searchInput.addEventListener('input', (e) => {
							const searchTerm = e.target.value.toLowerCase();
							const countries = countryList.querySelectorAll('li');

							countries.forEach(country => {
								const countryName = country.textContent.toLowerCase();
								if (countryName.includes(searchTerm)) {
									country.style.display = 'block';
								} else {
									country.style.display = 'none';
								}
							});
						});
					}

					// Select country
					if (countryList) {
						countryList.addEventListener('click', (e) => {
							if (e.target.tagName === 'LI') {
								const countryName = e.target.getAttribute('data-displayname');
								const countryCode = e.target.getAttribute('data-country-code');

								countryInput.value = countryName;
								if (countryCodeInput) {
									countryCodeInput.value = `+${countryCode}`;
								}

								dropdownList.style.display = 'none';
							}
						});
					}

					// Close dropdown when clicking outside
					document.addEventListener('click', (e) => {
						if (!countryInput.contains(e.target) && !dropdownList.contains(e.target)) {
							dropdownList.style.display = 'none';
						}
					});
				}
			};

			// Setup after a short delay to ensure DOM is ready
			setTimeout(setupCountryDropdown, 100);
		}
	}, [showModal]);

	// Handle gender selection
	const handleGenderChange = (gender) => {
		const maleRadio = document.querySelector('input[value="1"]');
		const femaleRadio = document.querySelector('input[value="2"]');
		const maleSpan = document.querySelector('.male .radio');
		const femaleSpan = document.querySelector('.female .radio');

		if (gender === 'male') {
			if (maleRadio) maleRadio.checked = true;
			if (femaleRadio) femaleRadio.checked = false;
			if (maleSpan) maleSpan.classList.add('active');
			if (femaleSpan) femaleSpan.classList.remove('active');
		} else {
			if (maleRadio) maleRadio.checked = false;
			if (femaleRadio) femaleRadio.checked = true;
			if (maleSpan) maleSpan.classList.remove('active');
			if (femaleSpan) femaleSpan.classList.add('active');
		}
	};

	const handleStartPay = (policy) => {
		startPayment({
			referenceId: `policy-card-${policy.id}`,
			amount: policy.premium,
			policyMeta: {
				policyId: policy.id,
				policyNumber: policy.policyNumber || policy.product || policy.id,
				companyId: policy.companyId || null,
				insurer: policy.insurer,
				product: policy.product,
			},
			description: `${policy.product} - Initial Premium`,
		});
	};

	return (
		<>
			<PageSerch />
			<DynamicBreadcrumbs />

			<div className="container py-4 policy-wrap">
				{/* <nav aria-label="breadcrumb" className="mb-3">
				<ol className="breadcrumb">
					<li className="breadcrumb-item"><a href="/">Home</a></li>
					<li className="breadcrumb-item active" aria-current="page">Life Insurance</li>
				</ol>
			</nav> */}

				<div className="">
					<h2 className="mb-3 text-start" style={{ textAlign: 'start' }}>Top Life Insurance Plans in India 2025</h2>
					<div className="d-flex justify-content-start gap-2 mb-4" style={{ gap: 10 }}>
						{tabs.map(t => (
							<button
								key={t.key}
								onClick={() => setActiveTab(t.key)}
								className={`btn ${activeTab === t.key ? 'btn-primary' : 'btn-outline-secondary'} policy-tabs`}
							>
								{t.label}
							</button>
						))}
					</div>

					<div id="dc-twocolumns" className="dc-twocolumns dc-haslayout d-flex dc-enabled">
						<div className="policy-list-container col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9 order-first">
							{activeTab === 'term' && (
								<div className="policy-list">
									{policies.map(policy => (
										<article key={policy.id} className="policy-card" role="article" aria-label={`Insurance policy from ${policy.insurer}`}>
											<div className="card-body">
												<div className="row align-items-center g-3">
													<div className="col-md-4">
														<header className="insurer-head">
															{policy.logo ? (
																<img className="insurer-logo" src={policy.logo} alt={`${policy.insurer} logo`} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
															) : null}
															<h3 className="insurer-name">{policy.insurer}</h3>
														</header>
														<div className="product-name" role="text" aria-label={`Product: ${policy.product}`}>{policy.product}</div>
													</div>
													<div className="col-md-6">
														<div className="policy-metrics" role="group" aria-label="Policy metrics">
															<div className="policy-metric policy-meta">
																<div className="label">Life Cover</div>
																<div className="value" aria-label={`${policy.lifeCover} maximum coverage`}>{policy.lifeCover}</div>
																<div className="text-muted small">Max Limit: 99 yrs</div>
															</div>
															<div className="policy-metric policy-meta">
																<div className="label">Claim Settled</div>
																<div className="value" aria-label={`${policy.claimSettled} claim settlement rate`}>{policy.claimSettled}</div>
															</div>
															<div className="policy-metric policy-meta">
																<div className="label">Premium Starting</div>
																<div className="value" aria-label={`Starting premium ${policy.premium}`}>{policy.premium}</div>
															</div>
														</div>
													</div>
													<div className="col-md-2 text-md-end">
														<button className="policy-cta" onClick={() => { console.log('Check Premium clicked'); setModalTab('term'); setShowModal(true); }} aria-label={`Check premium for ${policy.product}`}>Check Premium</button>
														<button
															className="policy-cta pay"
															style={{ marginTop: '8px' }}
															onClick={() => handleStartPay(policy)}
															disabled={processingKey === `policy-card-${policy.id}`}
														>
															{processingKey === `policy-card-${policy.id}` ? 'Processing...' : 'Start Pay'}
														</button>
														<div className="policy-save mt-1" role="text" aria-label={`Savings: ${policy.savings}`}>{policy.savings}</div>
													</div>
												</div>

												<div className="row mt-3">
													<div className="col-12">
														<div className="policy-features mb-3" role="list" aria-label="Key features">
															<div className="policy-pill" role="listitem">
																<span className="tick" aria-hidden="true">✓</span>
																<span>100% payout on Terminal illness</span>
															</div>
															<div className="policy-pill" role="listitem">
																<span className="tick" aria-hidden="true">✓</span>
																<span>Option to delay 12 Months premium</span>
															</div>
														</div>
													</div>
													<div className="col-12">
														<div className="policy-footer-badges" role="list" aria-label="Additional benefits">
															<div className="footer-badge orange" role="listitem">
																<span aria-hidden="true">🟠</span>
																<span>Full refund of premium</span>
															</div>
															<div className="footer-badge green" role="listitem">
																<span aria-hidden="true">✅</span>
																<span>Upto 15% discount included</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</article>
									))}
								</div>
							)}

							{activeTab === 'investment' && (
								<div>
									<div className="inv-summary">
										<div className="inv-pill"><span className="label">You Invest:</span><span className="value">₹10,000</span><span className="label">/month</span></div>
										<div className="inv-pill"><span className="label">Invest For:</span><span className="value">10 Years</span></div>
										<div className="inv-pill"><span className="label">Age:</span><span className="value">30 Year</span></div>
									</div>

									<div className="inv-list">
										{investmentPlans.map(plan => (
											<div key={plan.id} className="inv-card">
												<div className="card-body">
													<div className="row align-items-center g-3">
														<div className="col-md-4 d-flex align-items-center gap-3">
															{plan.logo ? <img className="insurer-logo" src={plan.logo} alt={plan.insurer} onError={(e) => { e.currentTarget.style.display = 'none'; }} /> : null}
															<div>
																<div className="insurer-name">{plan.insurer}</div>
																<div className="plan-name">{plan.product}</div>
															</div>
														</div>
														<div className="col-md-3">
															<div className="label text-muted">10 Yr Returns</div>
															<div className="inv-return">{plan.returns}</div>
															<div className="inv-badge">{plan.returnsBadge}</div>
														</div>
														<div className="col-md-3">
															<div className="label text-muted">Lump sum Payout</div>
															<div className="fs-4 fw-bold" style={{ color: '#0b4fe0' }}>{plan.payout}</div>
															<div className="text-muted small">{plan.payoutNote}</div>
														</div>
														<div className="col-md-2 text-md-end">
															<button className="know-btn" onClick={() => { console.log('Know More clicked'); setModalTab('investment'); setShowModal(true); }}>Know More</button>
														</div>
													</div>
												</div>
											</div>
										))}
									</div>
								</div>
							)}
						</div>

						<div className="col-12 col-md-5 col-lg-4 col-xl-3 order-last">
							<PageSidebar />
						</div>
					</div>



						{showModal && (
							<div className="modal-overlay" onClick={() => { setShowModal(false); }}>
								<div className="policy-modal" onClick={(e) => e.stopPropagation()}>
									<div className="modal-header">
										<div className="modal-tabs">
											<button className={`tab ${modalTab === 'term' ? 'active' : ''}`} onClick={() => setModalTab('term')}>Term Insurance</button>
											<button className={`tab ${modalTab === 'investment' ? 'active' : ''}`} onClick={() => setModalTab('investment')}>Investment plans</button>
										</div>
										<button className="close" onClick={() => setShowModal(false)}>×</button>
									</div>
									<div className="modal-body">
										<div className="modal-title">
											{modalTab === 'term' ? 'Protect your family today and get ₹1 Crore' : 'Grow Your Wealth With Protection (in-built life cover)'}
										</div>
										{modalTab === 'term' && <div className="modal-sub">@485/month+</div>}

										{modalTab === 'term' && (
											<div className="form_box term term-active">
												<div className="term-bg">
													<ul className="forminput">
														<li className="noborder mt0">
															<div className="genderselect">
																<div className="male" onClick={() => handleGenderChange('male')}>
																	<input type="radio" id="Male" name="radio-group-gender" value="1" defaultChecked className="hide" />
																	<label htmlFor="Male">Male</label>
																	<span className="radio active" value="1"></span>
																</div>
																<div className="female" onClick={() => handleGenderChange('female')}>
																	<input type="radio" id="Female" name="radio-group-gender" value="2" className="hide" />
																	<label htmlFor="Female">Female</label>
																	<span className="radio" value="2"></span>
																</div>
															</div>
														</li>
														<li className="has_radio">
															<span className="form_icon ico usericon"></span>
															<input name="userName" id="userName" type="text" className="small userName" placeholder="Your Name" maxLength="40" />
															<div className="err"></div>
														</li>
														<li className="has_radio">
															<span className="form_icon ico birthdate"></span>
															<input type="text" className="fullWidht dob" placeholder="Date of Birth (DD/MM/YYYY)" id="dob" maxLength="10" />
															<div className="err"></div>
															<div className="ageyears"></div>
														</li>
														<li className="registration_check">
															<span className="form_icon ico mobile-ico"></span>
															<div className="dropdown">
																<input type="text" id="termCountry" name="country" value="India" data-country-code="91" placeholder="Select Country" readOnly required />
																<div className="dropdown-list" id="dropdownList" style={{ display: 'none' }}>
																	<input type="text" id="searchCountry" placeholder="Country" />
																	<ul id="countryList" className="countryListSearch">
																		<li data-displayname="India" data-min="10" data-max="10" data-country-code="91" data-country="India">India (+91)</li>
																		<li data-displayname="UAE" data-min="9" data-max="9" data-country-code="971" data-country="United arab emirates">United arab emirates (+971)</li>
																		<li data-displayname="Saudi" data-min="9" data-max="9" data-country-code="966" data-country="Saudi arabia">Saudi arabia (+966)</li>
																		<li data-displayname="USA/Canada" data-min="10" data-max="10" data-country-code="1" data-country="Usa/canada">Usa/canada (+1)</li>
																		<li data-displayname="UK" data-min="10" data-max="10" data-country-code="44" data-country="United kingdom">United kingdom (+44)</li>
																		<li data-displayname="Australia" data-min="9" data-max="9" data-country-code="61" data-country="Australia">Australia (+61)</li>
																		<li data-displayname="Singapore" data-min="8" data-max="8" data-country-code="65" data-country="Singapore">Singapore (+65)</li>
																	</ul>
																</div>
															</div>
															<input type="text" id="countryCode" name="countryCode" maxLength="4" placeholder="+Code" readOnly />
															<input type="text" name="mobNumber" className="small mobNumber pd10" placeholder="Mobile Number" minLength="10" maxLength="10" />
															<div className="err"></div>
														</li>
														<li className="noborder">
															<button className="submit_cta" id="btnSubmitTerm">View Term Quotes</button>
														</li>
													</ul>
													<span className="termCondition">
														By clicking on "View Term Quotes" you agree to our <a href="https://www.policybazaar.com/legal-and-admin-policies/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://www.policybazaar.com/legal-and-admin-policies/#termsofuse" target="_blank" rel="noopener noreferrer">Terms of use</a>
													</span>
													<span className="termCondition">
														Tax benefit is subject to changes in tax laws
													</span>
													<div className="form-whatsapp">
														<i className="icon"></i>Get Updates on WhatsApp
														<label className="switch slBtn">
															<input type="checkbox" value="1" defaultChecked />
															<span className="slider round"></span>
														</label>
													</div>
												</div>
											</div>
										)}

										{modalTab === 'investment' && (
											<div className="form_box investment investment-active show">
												<div className="investment-bg">
													<ul className="forminput">
														<li className="has_radio">
															<span className="form_icon ico usericon"></span>
															<input name="userName" id="userName" className="userName" type="text" placeholder="Your Name" maxLength="40" />
															<div className="err"></div>
														</li>
														<li className="registration_check">
															<span className="form_icon ico mobile-ico"></span>
															<select className="countybox">
																<option data-displayname="India" data-min="10" data-max="10" data-country-code="91" value="392" selected>India</option>
																<option data-displayname="UAE" data-min="9" data-max="9" data-country-code="971" value="375">United arab emirates</option>
																<option data-displayname="Saudi" data-min="9" data-max="9" data-country-code="966" value="308">Saudi arabia</option>
																<option data-displayname="USA/Canada" data-min="10" data-max="10" data-country-code="1" value="378">Usa/canada</option>
																<option data-displayname="UK" data-min="10" data-max="10" data-country-code="44" value="376">United kingdom</option>
																<option data-displayname="Australia" data-min="9" data-max="9" data-country-code="61" value="24">Australia</option>
																<option data-displayname="Singapore" data-min="8" data-max="8" data-country-code="65" value="313">Singapore</option>
															</select>
															<div className="cCode" data-country-id="392" data-country-code="91">+91</div>
															<input type="text" name="mobNumber" className="small mobNumber pd10" placeholder="Mobile Number" minLength="10" maxLength="10" />
															<div className="err"></div>
														</li>
														<li className="has_radio hide">
															<span className="form_icon ico email"></span>
															<input type="text" name="EmailId" id="EmailId" className="small EmailId" placeholder="Your Email" maxLength="40" />
															<div className="err"></div>
														</li>
														<li className="noborder">
															<button className="submit_cta" id="btnSubmitInvestment">View Investment Plans</button>
														</li>
													</ul>
													<span className="termCondition">
														By clicking on "View Investment Plans" you agree to our <a href="https://www.policybazaar.com/legal-and-admin-policies/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://www.policybazaar.com/legal-and-admin-policies/#termsofuse" target="_blank" rel="noopener noreferrer">Terms of use</a><br /> Tax benefit is subject to changes in tax laws
													</span>
													<div className="form-whatsapp">
														<i className="icon"></i>Get Updates on WhatsApp
														<label className="switch slBtn">
															<input type="checkbox" value="1" defaultChecked />
															<span className="slider round"></span>
														</label>
													</div>
												</div>
											</div>
										)}
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</>
			);
}


